"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchLoupeIcon24Solid = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.SearchLoupeIcon24Solid = forwardRef_1.forwardRef('SearchLoupeIcon24Solid', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 24 }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11 1.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75a9.708 9.708 0 0 0 5.954-2.028l4.135 4.135a1.25 1.25 0 1 0 1.768-1.768l-4.135-4.135A9.707 9.707 0 0 0 20.75 11c0-5.385-4.365-9.75-9.75-9.75ZM3.75 11a7.25 7.25 0 1 1 14.5 0 7.25 7.25 0 0 1-14.5 0Z" })));
});
